// extracted by mini-css-extract-plugin
export default {"seo-data":"h11D9","seoData":"h11D9"};